import { useGlobalStore } from "@/store/GlobalStore";
import { useSearchParams } from "react-router-dom";
import {
  PictureNormalRechargeCard,
  PictureNormalRechargeWrapper,
} from "./atom";
import { usePictureTopUpStore } from "../../store";
import {
  PictureNormalRechargeInfo,
  PictureNormalRules,
} from "../../constants/picture-balance-info";
import { useEffect, useState } from "react";
import {
  ActivityRuleAndCoupon,
  CommonCardListWrapper,
  PictureCouponCode,
} from "../../atom";
import CheckIcon from "@/assets/icons/topup/check";
import ActivityRule from "@/components/top-up/components/activity-rule";
import { useTranslation } from "react-i18next";

export function PictureNormalRecharge() {
  const { currencySymbol } = useGlobalStore();
  const { t } = useTranslation("topup");
  const [openRuleDrawer, setOpenRuleDrawer] = useState(false);
  const [searchParams] = useSearchParams();
  const card = searchParams.get("chooseCard");
  const [checkCardPrice, setCheckCardPrice] = useState(
    PictureNormalRechargeInfo[0]
  );
  const { setter } = usePictureTopUpStore();
  const rechargeSecondActiveName = usePictureTopUpStore(
    (state) => state.rechargeSecondActiveName
  );
  const isCheckCard = usePictureTopUpStore((state) => state.isCheckCard);
  const verifyRechargeInfo = usePictureTopUpStore(
    (state) => state.verifyRechargeInfo
  );
  const openCouponModal = () => {
    setter((state) => {
      state.showCouponCodeModal = true;
      if (verifyRechargeInfo.couponNO) {
        state.inputCode = verifyRechargeInfo.couponNO;
      }
    });
  };

  useEffect(() => {
    if (card) {
      setCheckCardPrice(Number(card));
      if (rechargeSecondActiveName === "second-tab-first-recharge") return;
      setter({
        amount: Number(card),
        isCheckCard: true,
      });
    } else {
      setCheckCardPrice(PictureNormalRechargeInfo[0]);
      if (rechargeSecondActiveName === "second-tab-first-recharge") return;
      setter({
        amount: PictureNormalRechargeInfo[0],
        isCheckCard: true,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rechargeSecondActiveName]);

  return (
    <PictureNormalRechargeWrapper>
      <ActivityRuleAndCoupon>
        <ActivityRule
          ruleList={PictureNormalRules}
          openRuleDrawer={openRuleDrawer}
          changeDrawer={(val) => {
            setOpenRuleDrawer(val);
          }}
        />
        <PictureCouponCode onClick={openCouponModal}>
          {t("renderbus_recharge_redemption_code")}
        </PictureCouponCode>
      </ActivityRuleAndCoupon>
      <CommonCardListWrapper>
        {PictureNormalRechargeInfo.map((item) => {
          const isActiveCard = checkCardPrice === item && isCheckCard;
          return (
            <PictureNormalRechargeCard
              isActive={isActiveCard}
              padding={"0 16px"}
              onClick={() => {
                setCheckCardPrice(item);
                setter((state) => {
                  state.amount = item;
                  state.isCheckCard = true;
                });
              }}
              key={item}
            >
              <div className="recharge-price">
                <div>
                  <span className="unit">{currencySymbol}</span>
                  <span className="price">{item}</span>
                </div>
                {isActiveCard && <CheckIcon />}
              </div>
            </PictureNormalRechargeCard>
          );
        })}
      </CommonCardListWrapper>
    </PictureNormalRechargeWrapper>
  );
}
